import type { NoticeTone } from '../../primitives/AppNotice/notice-types'
import type { DesignRun, DesignRunErrorCode } from '@/types/design'

/** What the run notice reports: the run history still loading, or the latest run's state. */
export type DesignRunNoticeState = 'loading' | 'running' | 'completed' | 'failed'

interface DesignRunNoticeEntry {
  tone: NoticeTone
  /** i18n key of the notice line; it may read `reason`. */
  messageKey: string
}

/** The one table the run notice reads: state to tone and copy. */
export const DESIGN_RUN_NOTICE: Record<DesignRunNoticeState, DesignRunNoticeEntry> = {
  loading: { tone: 'progress', messageKey: 'design.status.loading' },
  running: { tone: 'progress', messageKey: 'design.status.running' },
  completed: { tone: 'success', messageKey: 'design.status.completed' },
  failed: { tone: 'error', messageKey: 'design.status.failed' },
}

/** The notice state for a run, or `null` when there is nothing to report. */
export function designRunNoticeState(
  run: DesignRun | null,
  loading: boolean,
): DesignRunNoticeState | null {
  if (loading) return 'loading'
  return run ? run.status : null
}

/** The i18n key that says in plain words why a run failed. */
export function designRunReasonKey(code: DesignRunErrorCode | null): string {
  return code ? `design.status.reasons.${code}` : 'design.status.reasons.unknown'
}
